var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserCreateForm',{attrs:{"userType":_vm.UserType.MERCHANT,"userPermissions":_vm.userPermissions}})}
var staticRenderFns = []

export { render, staticRenderFns }